import { aemAxiosInstance } from "@/constants/api"
import {
  COMPONENT_TYPES,
  GLOBAL_CONFIGURATION_ENDPOINT,
  GRADIENT_DICTIONARY,
  SEARCH_TABS,
  PROMO_COLUMNS,
} from "@/constants"
import {
  MAIN_CONTENT_AREA,
  SEARCH_RESULTS,
} from "@/components/Shared/Search/v1/InspirationTile/analytics/constant"
import { recursiveDataFunction } from "@/utils/index"
import { sanitizeText, normalizePromoTextPlacement } from "@/utils/textUtils"
import { getShortenedUrl } from "@/utils/location"

export const getPromoData = async link => {
  const finalData = aemAxiosInstance({
    url: GLOBAL_CONFIGURATION_ENDPOINT,
    params: {
      path: link + ".model.json",
    },
  })
    .then(res => {
      const dat = recursiveDataFunction(res?.data, COMPONENT_TYPES?.PROMOBANNER)
      return dat[0]
    })
    .catch(err => {
      console.log("Failed to get compare attributes JSON file", err)
    })
  return finalData
}

const getAnalyticsDataLayer = (data, promoIndex, shortenedUrl) => {
  const ctaLink = data?.ctaLabel.toLowerCase()
  const componentInfo = {
    eventAction: `${SEARCH_RESULTS}:${SEARCH_TABS.PRODUCTS}:${MAIN_CONTENT_AREA}:${ctaLink}`,
    eventName: `${SEARCH_RESULTS}:${SEARCH_TABS.PRODUCTS}:${MAIN_CONTENT_AREA}:${ctaLink}`,
    componentMessage: `promo-${promoIndex}`,
    componentName: sanitizeText(data?.title).toLowerCase(),
    componentType: "internal campaign",
  }
  const eventInfo = {
    eventAction: `${SEARCH_RESULTS}:${SEARCH_TABS.PRODUCTS}:${MAIN_CONTENT_AREA}:${ctaLink}`,
    eventName: `${SEARCH_RESULTS}:${SEARCH_TABS.PRODUCTS}:${MAIN_CONTENT_AREA}:${ctaLink}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: ctaLink,
    internalLinkPosition: "search",
    internalLinkType: `${SEARCH_RESULTS}:internal campaign`,
    internalLinkZoneName: `${SEARCH_RESULTS}:${SEARCH_TABS.PRODUCTS}:${MAIN_CONTENT_AREA}`,
    internalLinkURL:
      typeof window !== "undefined"
        ? window.location.origin + shortenedUrl
        : "",
    clickInternalLinks: "true",
  }
  if (window.adobeDataLayer) {
    const { adobeDataLayer: { getState } = {} } = window
    const page = (getState && getState("page")) || {}
    window.adobeDataLayer.push({
      event: "cmp:click",
      componentInfo,
      eventInfo,
      page,
    })
  }
}

const scrollToTop = () => {
  const scrollStep = -window.scrollY / (1000 / 15) // scroll speed here
  const scrollInterval = setInterval(() => {
    if (window.scrollY !== 0) {
      window.scrollBy(0, scrollStep)
    } else {
      clearInterval(scrollInterval)
    }
  }, 15)
}

const setPromoJsonData = async (
  data = {},
  promoIndex = 0,
  desktopPromo = "one-column"
) => {
  // Store the shortened URL in a separate variable
  const shortenedUrl = await getShortenedUrl(data?.ctaLink)

  const promoProps = {
    mod: "black",
    promoKey: `promo-${promoIndex}`, // Unique key for each promo
    heading: {
      text: sanitizeText(data?.title) || "",
    },
    image: {
      src: data?.imageUrl,
      alt: data?.altText,
      "data-mode": "smartcrop",
      role: "presentation",
    },
    CTA: {
      text: data?.ctaLabel,
      href: shortenedUrl,
      target: data?.isNewTab === "true" ? "_blank" : "_self",
      onClick: () => {
        if (shortenedUrl === window.location.pathname) {
          scrollToTop()
        }
        getAnalyticsDataLayer(data, promoIndex, shortenedUrl)
      },
    },
    textPlacement: normalizePromoTextPlacement(data?.contentPosition),
    gradientDirection: GRADIENT_DICTIONARY[data?.gradientPosition[0]],
    opacity: parseInt(data?.gradientOpacity),
    type: PROMO_COLUMNS[desktopPromo],
    style: (() => {
      return { aspectRatio: "1 / 1" }
    })(),
  }
  return promoProps
}

export const getPromoBannerProps = async ({
  xfLink,
  promoIndex = 0,
  desktopPromo,
}) => {
  if (xfLink) {
    const link = xfLink?.split(".html")[0]
    if (link) {
      try {
        const data = await getPromoData(link)
        const promoProps = await setPromoJsonData(
          data,
          promoIndex,
          desktopPromo
        )
        return promoProps
      } catch (error) {
        console.error(error)
        return null
      }
    }
  }
}
